import { render, staticRenderFns } from "./detailTable14.vue?vue&type=template&id=5daf9f85&scoped=true&"
import script from "./detailTable14.vue?vue&type=script&lang=js&"
export * from "./detailTable14.vue?vue&type=script&lang=js&"
import style0 from "./detailTable14.vue?vue&type=style&index=0&id=5daf9f85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf9f85",
  null
  
)

export default component.exports